import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import NotificationBell from './NotificationBell';
import '../styles/Navbar.css';

const Navbar = () => {
  const { user, loading, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsUserMenuOpen(false);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const handleLogout = () => {
    logout();
    closeMenu();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src="/logo.png" alt="WennWieWo" className="navbar-logo-img" />
        </Link>

        <div className="navbar-mobile-right">
          {!loading && user && <NotificationBell />}
          <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
            <span className={isMenuOpen ? 'open' : ''}></span>
            <span className={isMenuOpen ? 'open' : ''}></span>
            <span className={isMenuOpen ? 'open' : ''}></span>
          </button>
        </div>

        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          {!loading && (user ? (
            <>
              <Link to="/submit" className="btn-submit-event" onClick={closeMenu}>Dein Event</Link>

              {/* Desktop: Icons */}
              <div className="navbar-right-icons desktop-only">
                <Link to="/faq" className="faq-icon-btn" onClick={closeMenu} title="FAQ">?</Link>
                <NotificationBell />
                <div className="user-menu-container">
                  <button className="user-menu-btn" onClick={toggleUserMenu} title="Benutzermenü">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </button>
                  {isUserMenuOpen && (
                    <div className="user-dropdown">
                      <Link to={`/organizer/${user._id || user.id}`} onClick={closeMenu}>Mein Profil</Link>
                      <Link to="/account" onClick={closeMenu}>Mein Account</Link>
                      {user.role === 'admin' && <Link to="/admin" onClick={closeMenu}>Admin</Link>}
                      <button onClick={handleLogout} className="dropdown-logout">Abmelden</button>
                    </div>
                  )}
                </div>
              </div>

              {/* Mobile: Textlinks */}
              <div className="mobile-only mobile-user-links">
                <Link to={`/organizer/${user._id || user.id}`} onClick={closeMenu}>Mein Profil</Link>
                <Link to="/account" onClick={closeMenu}>Mein Account</Link>
                {user.role === 'admin' && <Link to="/admin" onClick={closeMenu}>Admin</Link>}
                <Link to="/faq" onClick={closeMenu}>FAQ</Link>
                <button onClick={handleLogout} className="mobile-logout-btn">Abmelden</button>
              </div>
            </>
          ) : (
            <>
              <Link to="/register?redirect=/submit" className="btn-submit-event" onClick={closeMenu}>Dein Event</Link>
              <Link to="/login" onClick={closeMenu}>Anmelden</Link>
            </>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
